<template>
    <zen-tooltip
        :content="tooltipText"
        placement="top"
        v-slot="{ setReference, ariaAttrs, show, hide }"
    >
        <button
            type="button"
            :ref="setReference"
            v-bind="ariaAttrs"
            @click="$emit('click')"
            @mouseenter="show"
            @mouseleave="hide"
            @focus="show"
            @blur="hide"
            class="cursor-pointer p-2 text-sky-600 hover:bg-sky-200 hover:rounded-full transition-colors duration-150"
        >
            <slot />
            <span class="sr-only">{{ srText }}</span>
        </button>
    </zen-tooltip>
</template>

<script>
export default {
    emits: ['click'],
    props: {
        srText: {
            required: true,
            type: String,
        },
        tooltipText: {
            required: true,
            type: String,
        },
    },
}
</script>
